<template>
  <div>
    <div class="BoxWide" >
      <div class="RegistroInterventi">         
        <div class="TabellaRegistro">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td class="TRCod">
                  <div class="TRIndex">
                    <div>Codice intervento</div>
                    <div>{{ this.intervento.CodiceIntervento }}</div>
                  </div>
                </td>
                <td class="TREff">
                  <div class="TRIndex Bordered">
                    <div>Data Prevista</div>
                    <div>{{ this.formatDate(this.intervento.DataDaEffettuarsiEntro) }}</div>
                  </div>
                </td>
                <td class="TRTip">
                  <div class="TRIndex">
                    <div>Tipo</div>
                    <div>{{ this.intervento.Tipo ?? "-" }}</div>
                  </div>
                </td>
                <td class="TRRic">
                  <div class="TRIndex">
                    <div>Data/Richiesto da</div>
                    <div>{{ this.formatDateNoOre(intervento.DataAssegnazione) + " - " + intervento.FirmaAssegnazione ?? " "}}</div>
                  </div>
                </td>
                <td class="TRSit">
                  <div class="TRIndex">
                    <div>Sito / Unità</div>
                      <div>
                        {{ this.$store.getters.getDescrizioneOperativa(this.intervento.CodiceSito) ?? "-" }}
                        <Popper>  
                          <a class="fancybox.iframe FancySizes InfoPopUpOpen" style="font-size: 13px; text-transform: lowercase;">i</a>                        
                          <template #content>
                            <label for="denominazione">Denominazione:</label>
                            <p id = "denominazione">{{ this.$store.getters.getDescrizioneSito(intervento.CodiceSito)}}</p>
                            <br>
                            <label for = "Indirizzo">Indirizzo:</label>
                            <p id = "Indirizzo">{{this.$store.getters.getIndirizzoSito(intervento.CodiceSito)}}</p>
                            <br>
                            <label for="prov">Provincia:</label>
                            <p id ="prov">{{this.$store.getters.getProvinciaSito(intervento.CodiceSito)}}</p>
                            <br> 
                            <hr>
                            <br>  
                            <label for="prov">Descrizione Unita:</label>
                            <p id ="prov"> {{ this.intervento.DescrizioneUnita ?? "-" }} </p>                 
                          </template>
                        </Popper>
                      </div>
                  </div>
                </td>
                <td class="TRSta">
                  <div class="TRIndex">
                    <div>Stato</div>
                    <div>
                      Assegnato
                        <Popper>  
                            <a class="fancybox.iframe FancySizes InfoPopUpOpen" style="font-size: 13px; text-transform: lowercase;">i</a>                        
                            <template #content>
                              <label for="noteAsseganz">Note Assegnazione:</label>
                              <p id = "noteAsseganz" class="noteInfo">{{intervento.NoteAssegnazione ?? "-" }}</p>
                              <br>
                              <hr>
                              <br>
                              <label for = "dataPresaInCarico">Data Non Oltre:</label>
                              <p id = "dataPresaInCarico">{{this.formatDateNoOre(intervento.DataNonOltre) ?? "-"}}</p>
                              <br>
                              <label for="notePresaInCarico">Firma Assegnazione:</label>
                              <p id ="notePresaInCarico">{{intervento.FirmaAssegnazione ?? "-" }}</p>                      
                            </template>
                        </Popper>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="ToggleButton">
          <div class="Dettagli Button Iconed Stroked Toggled ExtraSmall" @click="this.mostraAttivita(index, this.intervento.CodiceIntervento, this.intervento.SysChiaveglobale, $event)">
            <span>Dettagli</span>
          </div>
        </div>
        <div class="ToggleButton">
          <div class="Button CustomColor2 ExtraSmall">
            <a href="javascript:void(0)" @click="this.presaInCarico(this.intervento.SysChiaveglobale)">Presa in carico</a>        
          </div>
        </div>
      </div>    
      <div class="TabHolder PannelloDettagli" style="display:none;" :id="'pannDett' + index ">
          <keep-alive>
          <component
            :is="gridAttivita"
            :codiceIntervento="this.intervento.CodiceIntervento"
          > 
          </component>
          </keep-alive>
    </div>
  </div>
  <PresaInCaricoModal v-model="this.showModal" :chiaveIntervento="this.chiaveIntervento"></PresaInCaricoModal>
  </div>
</template>

<script>

import {apiMixin, dateMixin, griglieInterventiMixin} from "/mixin.js";
import PresaInCaricoModal from "@/components/modals/PresaInCaricoModal.vue";
import GrigliaAttivitaInterventiAssegnati from "@/components/GrigliaAttivitaInterventiAssegnati.vue";
import EmptyComponent from "@/components/EmptyComponent.vue";
import Popper from "vue3-popper";

export default {
    name: "RigaInterventiAssegnati",
    data(){
        return {       
        showModal: false,       
        chiaveIntervento: "",
        showGridAttivita: false
        }    
    },
    components:{
        PresaInCaricoModal,
        GrigliaAttivitaInterventiAssegnati,
        EmptyComponent,
        Popper
    },
    computed: {
      gridAttivita(){           
        let comp = this.showGridAttivita ? "GrigliaAttivitaInterventiAssegnati" : "EmptyComponent"; 
        return comp;        
      }
    },
    mixins:[apiMixin, dateMixin, griglieInterventiMixin],
    props: {
        intervento: Object,
        index: Number
    },  
    methods: {
        presaInCarico: function(chiaveIntervento){
        this.chiaveIntervento = chiaveIntervento;
        this.showModal = true;
        },
        mostraAttivita: function(index, codiceIntervento, chiaveIntervento, e){
            this.chiaveIntervento = chiaveIntervento;
            var el = e.srcElement.parentElement;
                        
            if($(el).parent().parent().parent().hasClass('ChiusuraDettagli')){
                this.showGridAttivita = false;               
            }  
            else{
                this.showGridAttivita = true;               
            }
            this.gestisciTabDettagli(el, index, "pannDett", 'AperturaDettagli', 'ChiusuraDettagli');
        }
    }
}
</script>